import { Check, Loader2 } from 'lucide-react';
import { motion } from 'motion/react';

import type { ToolState } from '../tool-provider';

export interface ToolActivityProps {
  /** Model-authored, user-facing status sentence (already localized). */
  label: string;
  state: ToolState;
}

/**
 * Customer-facing activity line for a running tool: the model-authored
 * status sentence ("Searching the knowledge base…") with a spinner while
 * the tool runs and a check once it settled. Shown for tool calls that
 * carry a `label` and have no dedicated renderer — internal tool names and
 * arguments are never exposed here.
 */
export function ToolActivity({ label, state }: ToolActivityProps) {
  const isRunning = state === 'call' || state === 'call-partial';

  return (
    <motion.div
      className='flex items-center gap-1.5 px-1 py-0.5 text-xs text-chat-muted-foreground'
      initial={{ opacity: 0, y: 4 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.2 }}
    >
      {isRunning ? (
        <Loader2 className='size-3 shrink-0 animate-spin' />
      ) : (
        <Check className='size-3 shrink-0' />
      )}
      <span className='min-w-0 truncate'>{label}</span>
    </motion.div>
  );
}
